import { useQuery } from '@tanstack/react-query';
import { initializeApp } from 'firebase/app';
import {
    fetchAndActivate,
    getAll,
    getRemoteConfig,
} from 'firebase/remote-config';

import { getFirebaseConfig } from '../utils/firebaseConfig';

export function useRemoteConfig() {
    const query = useQuery({
        queryKey: ['firebaseConfig'],
        queryFn: async () => {
            try {
                const firebaseConfig = await getFirebaseConfig();
                if (!firebaseConfig) {
                    throw new Error('No Firebase config found from backend');
                }

                // Init Firebase app
                const app = initializeApp(firebaseConfig);
                // Init Remote Config
                const rc = getRemoteConfig(app);
                rc.settings = {
                    fetchTimeoutMillis: 60000,
                    minimumFetchIntervalMillis: 3600000,
                };
                await fetchAndActivate(rc);
                const allParams = getAll(rc);
                const configKeys = Object.keys(allParams);

                return { remoteConfig: rc, configKeys };
            } catch (e) {
                console.warn('Failed to fetch firebase remote config', e);
                return null;
            }
        },
        refetchOnReconnect: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    return {
        remoteConfig: query.data?.remoteConfig ?? null,
        configKeys: query.data?.configKeys ?? [],
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
    };
}
